import $ from "cash-dom";
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        var $selector = $(".slider");

        function init() {
            if ($selector.length) {
                if (log) console.log("%cfunction_slider.js initialized", "color: green;");

                function slideChangeHandler(_Swiper) {
                    var $instance = $(_Swiper.el);

                    $instance.parents(".layout").find(".description-wrapper .description").removeClass("on");
                    $instance
                        .parents(".layout")
                        .find(".description-wrapper .description")
                        .eq(_Swiper.activeIndex)
                        .addClass("on");
                }

                $selector.each(function (_i) {
                    var $instance = $(this).find(".swiper");
                    var autoplay = $instance[0].hasAttribute("data-autoplay");
                    var autoplayDuration = 3200;
                    var userHasClicked = false;
                    var indent =
                        getCssVarValue("--space-global") +
                        getCssVarValue("--space-column") +
                        getCssVarValue("--width-column");

                    var swiper = new Swiper($instance[0], {
                        centeredSlides: true,
                        spaceBetween: getCssVarValue("--space-column"),
                        // slidesOffsetBefore: indent,
                        // slidesOffsetAfter: indent,
                        slidesPerView: "auto",
                        speed: getCssVarValue("--duration-lg"),
                        // autoHeight: true,
                        modules: [Autoplay, Navigation, Pagination],
                        loop: autoplay,
                        // loopAdditionalSlides: 0,
                        allowTouchMove: true,
                        disabledClass: "pointer-none",
                        autoplay: autoplay
                            ? {
                                  delay: getCssVarValue("--duration-xl") * 2,
                                  disableOnInteraction: true,
                                  // reverseDirection: reverse,
                              }
                            : false,
                        navigation: {
                            nextEl: "[data-next]",
                            prevEl: "[data-prev]",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        },
                        on: {
                            slideChange: slideChangeHandler,
                        },
                    });

                    console.log(swiper);

                    $instance
                        .parents(".layout")
                        .find("[data-description]")
                        .each(function (_i, _el) {
                            var $clone = $(this).clone();

                            $clone.removeClass("hide").addClass("fade-in transition-md");
                            if (_i == 0) $clone.addClass("on");

                            $instance.parents(".layout").find(".description-wrapper").append($clone);
                        });

                    $instance
                        .on("mouseenter", function () {
                            $(this).find(".swiper-navigation").toggleClass("on");
                        })
                        .on("mouseleave", function () {
                            $(this).find(".swiper-navigation").toggleClass("on");
                        });
                });
            }
        }

        init();
    });
})();
